import React from 'react';
import {useInstance} from 'react-ioc';
import {Link} from 'react-router-dom';
import {CaretDownOutlined, MenuOutlined, ShoppingCartOutlined} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import {Badge, Button, Dropdown, Space} from 'antd';
import _ from 'lodash';
import {observer} from 'mobx-react-lite';

import {
    CANDLES,
    CART,
    CONTACT,
    DELIVERY,
    DIFFUSER,
    DINNER,
    HANDLER,
    INDEX,
    INTERIOR,
    toProductId
} from '../../config/routes';
import {Store} from '../../model/store/Store';
import {fullUrl} from '../../shared/helpers/fullUrl';
import {useWindowSize} from '../../shared/helpers/useWindowSize';

import logo from './logo.svg'

import cls from './Header.module.scss'

type MenuItem = Required<MenuProps>['items'][number];

export const Header = observer(() => {

    const {order} = useInstance(Store)

    const {width} = useWindowSize()

    const menu: MenuItem[] = [
        {key: 'aroma', label: <Link to={CANDLES}>Ароматические свечи</Link>},
        {key: 'handler', label: <Link to={HANDLER}>Свечи в интерьерных кашпо</Link>},
        {key: 'dinner', label: <Link to={DINNER}>Столовые свечи</Link>},
        {key: 'interior', label: <Link to={INTERIOR}>Предметы интерьера</Link>},
        {key: 'duffuser', label: <Link to={DIFFUSER}>Арома-диффузоры</Link>},
    ]

    const mobilemenu: MenuItem[] = [
        {key: DELIVERY, label: <Link to={DELIVERY}>Доставка и оплата</Link>},
        {key: CONTACT, label: <Link to={CONTACT}>Контакты</Link>},
        {key: 'catalog', label: 'Каталог', type: 'group', children: [
                {key: 'aroma', label: <Link to={CANDLES}>Ароматические свечи</Link>},
                {key: 'handler', label: <Link to={HANDLER}>Свечи в интерьерных кашпо</Link>},
                {key: 'dinner', label: <Link to={DINNER}>Столовые свечи</Link>},
                {key: 'interior', label: <Link to={INTERIOR}>Предметы интерьера</Link>},

            ]},
    ]

    const cart: MenuItem[] = [
        ..._.map(order.positions, item => (
            {
                key: item.documentId,
                label:
                    <Link to={toProductId(item.documentId)}>
                        <div className={cls.cart}>
                            <div className={cls.cart_img} style={{backgroundImage: `url(${fullUrl(item.url)})`}}/>
                            <h3>{item.name}</h3>
                            <div>{item.quantity} шт</div>
                        </div>
                    </Link>,
            }
        )),
        order.positions.length === 0 ? {
            key: 'empty',
            label: <span className={cls.empty}>В корзине пусто...</span>
        } : {
            key: 'order',
            label: <Link to={CART}><Button type={'primary'}>Оформить заказ</Button></Link>
        },
    ]

    return (
        <header className={cls.header}>
            <div className={cls.left}>
                <Link to={INDEX}>
                    <img src={logo} alt={'Daisy Logo'} className={cls.logo}/>
                </Link>
            </div>
            <div className={cls.middle}>
                {width > 768 &&
                <Space size={width > 1024 ? 32 : 16}>
                    <Dropdown menu={{items: menu}} overlayClassName={cls.drop}>
                        <Space size={8}>
                            Каталог
                            <CaretDownOutlined className={'brand'}/>
                        </Space>
                    </Dropdown>
                    <div><Link to={DELIVERY}>Доставка и оплата</Link></div>
                    <div><Link to={CONTACT}>Контакты</Link></div>
                </Space>
                }
            </div>
            <div className={cls.right}>
                {width <= 768 &&
                    <Dropdown menu={{items: mobilemenu}} overlayClassName={cls.drop}>
                        <MenuOutlined/>
                    </Dropdown>
                }
                <Dropdown menu={{items: cart}} overlayClassName={cls.drop}>
                    <Link to={CART}>
                        <Space size={8}>
                            <ShoppingCartOutlined/>
                            Корзина
                            {order.positions.length > 0 && <Badge count={order.positions.length} color={'#E08E79'}/>}
                        </Space>
                    </Link>
                </Dropdown>
            </div>
        </header>
    )
})